var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowUpRefraction(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.77604 19.4923C2.3241 19.7544 2.98088 19.5226 3.24299 18.9745L8.09613 8.82703L14.5001 14.8041C14.7271 15.0159 15.033 15.122 15.3424 15.0961C15.6518 15.0702 15.9358 14.9147 16.1244 14.6681L20.6506 8.74921V10.4999C20.6506 11.1074 21.1431 11.5999 21.7506 11.5999C22.3582 11.5999 22.8506 11.1074 22.8506 10.4999V5.4999C22.8506 4.89239 22.3582 4.3999 21.7506 4.3999H16.2506C15.6431 4.3999 15.1506 4.89239 15.1506 5.4999C15.1506 6.10742 15.6431 6.5999 16.2506 6.5999H19.5247L15.114 12.3677L8.5012 6.19574C8.2451 5.95672 7.89048 5.85397 7.54627 5.91905C7.20206 5.98414 6.90944 6.20928 6.7583 6.5253L1.2583 18.0253C0.996183 18.5734 1.22799 19.2301 1.77604 19.4923Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpRefraction);
export default __webpack_public_path__ + "static/media/arrow-up-refraction.c7d1541aa9c458137792704f1808d027.svg";
export { ForwardRef as ReactComponent };